import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { ThemeProvider } from './theme/ThemeContext';
import ProtectedRoute from './auth/ProtectedRoute';
import LoginPage from './auth/LoginPage';
import DashboardLayout from './layouts/DashboardLayout';
import SalesDashboard from './pages/SalesDashboard';
import MarketingDashboard from './pages/MarketingDashboard';
import Education from './pages/Education';
import Amo1c from './pages/Amo1c';
import AdminData from './pages/AdminData';
import AdminUsers from './pages/AdminUsers';

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<SalesDashboard />} />
              <Route path="marketing" element={<MarketingDashboard />} />
              <Route path="education" element={<Education />} />
              <Route path="amo-1c" element={<Amo1c />} />
              <Route path="admin/data" element={<AdminData />} />
              <Route path="admin/users" element={<AdminUsers />} />
            </Route>
          </Routes>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
